import * as Sentry from '@sentry/react'
const isDev = process.env.NODE_ENV === 'development'
import _ from 'lodash'

export const initSentry = () => {
    Sentry.init({
        dsn: 'https://7667adf7638aa448b7d4f648856d3c84@o41342.ingest.us.sentry.io/4506875153416192',
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            // Sentry.reactRouterV6BrowserTracingIntegration({
            //     useEffect: React.useEffect,
            //     useLocation,
            //     useNavigationType,
            //     createRoutesFromChildren,
            //     matchRoutes,
            // }),
            // Sentry.replayIntegration(),
            // ==============================
            // Redirect console.log/etc. to Sentry:
            // https://docs.sentry.io/platforms/javascript/configuration/integrations/captureconsole/
            // captureConsoleIntegration()
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        //  https://st_assessment2.fitme.jobs
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/st_assessment2\.fitme\.jobs/,
            /^https:\/\/st_assessment\.fitme\.jobs/,
        ],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        // replaysSessionSampleRate: 0.1,
        // replaysOnErrorSampleRate: 1.0,
    })
    console.log('Sentry initialized')
}

export const logException = (ctx: string, message: any, error?: Error) => {
    const errorStr = toStr(error)
    console.error(ctx, message, errorStr)
    message = toStr(message)
    if (isDev) return
    if (error) {
        Sentry.captureException(errorStr, {
            extra: { message, ctx },
            level: 'warning',
        })
    } else {
        Sentry.captureMessage(`${ctx}: ${message}`, 'error')
    }
}

export const info = (ctx: string, ...messages: any[]) => {
    console.info(ctx, messages?.map(toStr).join(', '))
    if (isDev) return
    Sentry.addBreadcrumb({
        category: ctx,
        message: messages?.map(toStr).join(', '),
        level: 'info',
    })
}

export const toStr = (o: any) => {
    if (typeof o === 'string') return o
    // if(!_.isNil(o)){
    //     const keys = Object.keys(o);
    //     if (o.length === 1 && typeof o[keys[0]] === 'string') {
    //         info('toStr()', [o[0]], o[keys[0]])
    //         return {
    //             [o[0]]: o[keys[0]],
    //         }
    //     }
    // }
    return JSON.stringify(o, getCircularReplacer(), ' ')
}

export const getCircularReplacer = () => {
    const seen = new WeakSet()
    return (key: string, value: any) => {
        // if (typeof value === 'string') {
        //     info('getCircularReplacer', key, value)
        // }
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return
            }
            seen.add(value)
        }
        return value
    }
}
